import { useState } from 'react';

import { EnvItem } from 'features/diagnostics/components/env-item';
import { Actionsheet } from 'native-base';
import { ScrollView, Text, View } from 'react-native';

import { Footer, InlineModal } from 'components/ui';
import { IMenuSelectionInput } from 'generated/graphql-gateway';
import { useMinimalCart } from 'hooks/use-minimal-cart';

import { CartDebugActionButton } from './cart-debug-action-button';

const deriveMenuSelections = (menuSelections: readonly IMenuSelectionInput[]) => {
  return menuSelections.map(selection => ({
    ...selection,
    menuSelections: deriveMenuSelections([...(selection.menuSelections ?? [])]),
  }));
};

const MinimalCartModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { cartEntries } = useMinimalCart();

  const menuSelections = cartEntries.map(entry => ({
    id: entry.id,
    menuSelections: deriveMenuSelections(entry.menuSelections ?? []),
  }));

  if (isOpen) {
    // eslint-disable-next-line no-console
    console.log({ minimalCart: menuSelections });
  }

  return (
    <InlineModal
      isOpen={isOpen}
      onClose={onClose}
      header={{ title: `Debug Minimal Cart`, variant: 'light' }}
    >
      <ScrollView>
        <EnvItem envKey={'Minimal cart'} value={JSON.stringify({ cart: menuSelections })} />
      </ScrollView>
    </InlineModal>
  );
};

export const CartDebugFooter = () => {
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isMinimalCartDebugOpen, setIsMinimalCartDebugOpen] = useState(false);
  const { emptyMinimalCart } = useMinimalCart();

  const handleViewActions = (type: 'viewMinimalCart' | 'viewPriceOrderInput') => {
    if (type === 'viewMinimalCart') {
      setIsMinimalCartDebugOpen(true);
    }

    if (type === 'viewPriceOrderInput') {
      // TODO: compute minimal cart
    }

    setIsViewOpen(false);
  };

  return (
    <Footer style={{ paddingVertical: 0, paddingHorizontal: 0 }}>
      <View style={{ flexDirection: 'column', gap: 6, flex: 1 }}>
        <Text style={{ fontSize: 16, fontWeight: 'bold', alignSelf: 'center' }}>total: $0.00</Text>
        <View style={{ flexDirection: 'row', gap: 6, flex: 1 }}>
          <CartDebugActionButton>Debug total</CartDebugActionButton>
          <CartDebugActionButton onPress={() => emptyMinimalCart()}>
            Clear Cart
          </CartDebugActionButton>
          <CartDebugActionButton onPress={() => setIsViewOpen(true)}>View...</CartDebugActionButton>
          <CartDebugActionButton onPress={() => setIsAddOpen(true)}>Add...</CartDebugActionButton>
        </View>
      </View>

      <Actionsheet isOpen={isViewOpen} onClose={() => setIsViewOpen(false)}>
        <Actionsheet.Content>
          <Actionsheet.Item onPress={() => handleViewActions('viewMinimalCart')}>
            View Minimal Cart
          </Actionsheet.Item>
          <Actionsheet.Item onPress={() => handleViewActions('viewPriceOrderInput')}>
            View Price Order Input
          </Actionsheet.Item>
        </Actionsheet.Content>
      </Actionsheet>

      <Actionsheet isOpen={isAddOpen} onClose={() => setIsAddOpen(false)}>
        <Actionsheet.Content>
          <Actionsheet.Item>Add Items</Actionsheet.Item>
          <Actionsheet.Item>Add Offers</Actionsheet.Item>
          <Actionsheet.Item>Add Rewards</Actionsheet.Item>
          <Actionsheet.Item>Add Donation</Actionsheet.Item>
          <Actionsheet.Item>Add Utensils</Actionsheet.Item>
        </Actionsheet.Content>
      </Actionsheet>

      <MinimalCartModal
        isOpen={isMinimalCartDebugOpen}
        onClose={() => setIsMinimalCartDebugOpen(false)}
      />
    </Footer>
  );
};
